import * as React from "react";
import "./styles.scss";
import { withTranslation } from "react-i18next";
import Friststep from "./Friststep";
import RegShell from "./RegShell";
import { Helmet } from "react-helmet-async";
function ChekoutPage({ t }) {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Sign up")}</title>
      </Helmet>
      <RegShell step={0}>
        <Friststep />
      </RegShell>
    </>
  );
}
export default withTranslation()(ChekoutPage);
